import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { KeyboardAvoidingView } from 'react-native';
import { Box } from "@/components/ui/box";
import i18n from 'i18n-js';
import React, { useEffect, useRef, useState } from 'react';
import { Platform, TouchableOpacity } from 'react-native';
import DraggableFlatList, { ScaleDecorator } from 'react-native-draggable-flatlist';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useDispatch, useSelector } from 'react-redux';

import Footer from '@/components/basic/Footer';
import ItemInput from '@/components/basic/ItemInput';
import MediaCarousell from '@/components/media/MediaCarousell';
import DeletableListElement from '@/components/workflow/DeletableListElement';
import useIsMounted from '@/hooks/mounted';
import { processWorkflow } from '@/stores/thunks';
import ImageSynced from '@/components/media/ImageSynced';
import { switchScreen } from '@/hooks/navigate';

const newTask = (taskid, user) => {
    return {
        owned: true, title: i18n.t('itemInput.title'), text: i18n.t('itemInput.text'), step: -1, id: taskid, media: [],
        steps: [
        ]
    }
}

export let updateStep

export default function WorkflowEdit({ route, navigation }) {
    const { taskid, title } = route.params
    const actions = [
        { icon: '', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: 'check', text: 'footer.create', component: 'BACK' }
    ]
    const mounted = useIsMounted()
    const scrollView = useRef()

    const user = useSelector(state => state.user) || { name: 'Unkown', demo: true }
    const newWorkflow = useSelector(state => !state.workflows[taskid])
    const task = useSelector(state => state.workflows[taskid] ? state.workflows[taskid] : newTask(taskid, user))
    const icons = useSelector(state => state.icons)
    const dispatch = useDispatch()
    const insets = useSafeAreaInsets();

    const [taskEdit, setTaskEdit] = useState(task)
    const [marked, setMarked] = useState(() => updMarked())

    function updMarked() {
        let mark = 0
        const marks = taskEdit.steps.map((step, s) => {
            if (step.type == 3) {
                mark = Math.max(0, Math.max(step.no ?? -1, step.yes ?? -1) - s - 1)
                return false
            }
            return mark-- > 0
        })
        return marks
    }

    updateStep = (step, idx) => {
        if (Array.isArray(step)) {
            setTaskEdit(prevTask => {
                return { ...prevTask, steps: step }
            })
        } else {
            setTaskEdit(prevTask => {
                let steps = [...prevTask.steps]
                steps[idx] = step
                return { ...prevTask, steps: steps }
            })
        }
    }

    const updateMedia = uris => {
        setTaskEdit(prevTask => (
            { ...prevTask, media: uris }
        ))
    }

    const updateTitle = text => {
        setTaskEdit(prevTask => (
            { ...prevTask, title: text }
        ))
    }

    const updateText = text => {
        setTaskEdit(prevTask => (
            { ...prevTask, text: text }
        ))
    }

    useEffect(() => {
        console.log('mounted', taskid)
        if (!newWorkflow) {
            scrollView.current.scrollToOffset({ offset: 350 })
        }
        navigation.setOptions({ title: i18n.t(title) })
    }, [])

    useEffect(() => {
        navigation.setOptions({ info: taskEdit.title })
        setMarked(updMarked())
    }, [taskEdit])

    // local state triggers update of redux state on unmount
    useEffect(() => {
        return () => {
            if (!mounted()) {
                console.log('save local task')
                dispatch(processWorkflow(taskEdit))
            }
        };
    }, [taskEdit, mounted])

    const actionStep = () => {
        switchScreen(navigation, 'StepEdit', { steps: taskEdit.steps, idx: taskEdit.steps.length, name: 'StdEdit' })
    }

    const deleteStep = (delIdx) => {
        console.log('onDelete', delIdx)
        // TODO: delete of images necessary?
        setTaskEdit(prevTask => {
            let steps = [...prevTask.steps]
            steps.splice(delIdx, 1)
            const map = prevTask.steps.map(step => steps.indexOf(step))
            // console.log(map)
            // Entscheiden steps need to be corrected wrt no/yes targets
            steps.forEach(step => {
                if (step.type == 3) {
                    step.no = map[step.no] == undefined ? -1 : map[step.no]
                    step.yes = map[step.yes] ?? -1
                }
            })
            return { ...prevTask, steps: steps }
        })
    }

    const sortSteps = (steps, from, to) => {
        if (from != to) {
            setTaskEdit(prevTask => {
                // map[oldIdx] = newIdx
                let newSteps = [...steps]
                const map = prevTask.steps.map(step => newSteps.indexOf(step))
                // Entscheiden steps need to be corrected wrt no/yes targets
                newSteps = steps.map((step, s) => {
                    if (step.type == 3) {
                        return { ...step, no: map[step.no] ?? -1, yes: map[step.yes] ?? -1 }
                    }
                    return step
                })
                return { ...prevTask, steps: newSteps }
            })
        }
    }

    const renderDraggableItem = ({ item, getIndex, drag, isActive }) => {
        const index = getIndex()
        const tag = taskEdit.steps.findIndex(step => step.no == index || step.yes == index)
        const elem =
            <ScaleDecorator>
                <TouchableOpacity className={`p-2`} disabled={isActive} onLongPress={drag} onPress={() => { switchScreen(navigation, 'StepEdit', { steps: taskEdit.steps, idx: index, name: 'StdEdit' }) }}>
                    <DeletableListElement idx={index} element={item} avatar={icons.types[item.type]} onDelete={deleteStep} marked={marked[index]} tag={tag > 0 ? tag + 1 : null} />
                </TouchableOpacity>
            </ScaleDecorator>
        return elem
    }

    return (
        <View className="bg-secondary-50 flex-1">
            <KeyboardAvoidingView behavior={Platform.select({ android: undefined, ios: 'padding' })} keyboardVerticalOffset={Platform.select({ android: 0, ios: 80 })} >
                <DraggableFlatList ref={scrollView} className="bg-secondary-50" contentContainerStyle={{ paddingBottom: 200 + insets.bottom }}
                    ListHeaderComponent={<>
                        <MediaCarousell uris={taskEdit.media} isEdit={true} update={updateMedia} />
                        <View >
                            {user.avatar && 
                            <Box className="border-2 border-white rounded-full absolute right-3 -top-7">
                                <ImageSynced className="border border-primary-900" key={user.avatar + '_' + user.refreshed} uri={user.avatar} refresh={user.refreshed} sync={'/contact/media/' + user.avatar} isAvatar={true} size='md' />
                            </Box>}
                        </View>
                        <VStack className="mx-3 mt-3">
                            <ItemInput item={taskEdit} updateTitle={updateTitle} updateText={updateText} infoTitle='infoTitle' infoText='infoDescription' />
                            <Text fon tSize='lg' className="mb-2 leading-lg text-secondary-500">{i18n.t('showWorkflowScreen.numberOfSteps', { steps: taskEdit.steps.length })}</Text>
                        </VStack>
                    </>}
                    data={taskEdit.steps}
                    onDragEnd={({ data, from, to }) => sortSteps(data, from, to)}
                    renderItem={renderDraggableItem}
                    keyExtractor={(item, index) => item?.title + index}
                />
            </KeyboardAvoidingView>
            <Footer navigation={navigation} actions={actions} button={{ action: actionStep, info: 'workflowEdit.addStep' }} />
        </View>
    );
}
